module.exports = __webpack_public_path__ + "static/media/mp1.43ee07e8.jpeg";